// Including these imports here ensures they don't get duplicated between separated bundles

// Used in simple-modal
import whenKey from "ally.js/src/when/key";

// Used in colour-list and simple modal
import isFocusable from "ally.js/src/is/focusable";



// WEBPACK FOOTER //
// ./client/src/site__evo/utilities/ally.js.bundle.js